import React from "react";

const ThemeModeContext = React.createContext();

export default ThemeModeContext;
